/*
 * Filter memory for the catalogue pages: /projects, /products, /cycles,
 * /intakes and /catalog.
 *
 * Only URL-backed keys can be listed here. Never remembered on any of them:
 * `page` (and `perPage` on /projects, which is derived from whether a cycle is
 * set; saving it would defeat that derivation).
 *
 * /catalog reads no search params at all: it has no tabs, and every card's
 * open modal and the billing-region filter are component state. So it gets no
 * rule. /projects/:id reads none either.
 *
 * On /products the search box and page are component state; on /products,
 * /cycles and /intakes the column filters (`useTableFilters`) are component
 * state too. Only the column sort lives in the URL there.
 */
import type { FilterMemoryRule } from './types';

export const FILTER_MEMORY_CATALOG: readonly FilterMemoryRule[] = [
  {
    path: '/projects',
    keep: [
      'search', // name search box
      'productId', // product filter
      'intakeId', // intake filter
      'cycleId', // cycle filter (also seeded with the current cycle on a bare arrival)
      'cityId', // city filter
      'regionId', // region filter
      'startDateAfter', // start date lower bound, YYYY-MM-DD
      'startDateBefore', // start date upper bound, YYYY-MM-DD
      'endDateAfter', // end date lower bound, YYYY-MM-DD
      'endDateBefore', // end date upper bound, YYYY-MM-DD
      'isActive', // active / inactive filter (absent = either)
      'sort', // sort member (absent = manual order)
      'order', // sort direction (absent with the manual sort)
    ],
  },
  {
    path: '/products',
    keep: [
      'sort', // column sort member
      'order', // column sort direction
    ],
  },
  {
    path: '/cycles',
    keep: [
      'sort', // column sort member
      'order', // column sort direction
    ],
  },
  {
    path: '/intakes',
    keep: [
      'cycleId', // cycle filter, mirrored with the Cycle column filter; also the target of blocked-cycle-delete links
      'sort', // column sort member
      'order', // column sort direction
    ],
  },
];
